import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';
import { Image } from 'react-native';

/**
 * Brand row at the top of a checkout's summary pane, with a badge when Paddle is in sandbox so a
 * test purchase is never mistaken for a real one.
 */
export const CheckoutBrandRow: React.FC<{ isProduction: boolean }> = ({ isProduction }) => (
  <Layout.Row align>
    <Image source={require('../../images/icons/logo.png')} style={{ width: 100, height: 36 }} />
    {isProduction ? null : (
      <Layout.Row align>
        <Spacer.Horizontal size={10} />
        <Layout.Column bg="warningXLight" radius={4} px={6} py={2}>
          <OpenSans.Custom size="xs-12" weight="bold-700" color="warningDark">
            TEST MODE
          </OpenSans.Custom>
        </Layout.Column>
      </Layout.Row>
    )}
  </Layout.Row>
);
